import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  min-height: 40px;\n  @media (max-width: ', ') {\n    display: none;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  min-height: 40px;\n  @media (max-width: ', ') {\n    display: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: 1px solid ', ';\n  cursor: pointer;\n  margin: 5px;\n  padding: 2px;\n  line-height: 1.5;\n\n  svg {\n    padding: 5px;\n  }\n'], ['\n  border: 1px solid ', ';\n  cursor: pointer;\n  margin: 5px;\n  padding: 2px;\n  line-height: 1.5;\n\n  svg {\n    padding: 5px;\n  }\n']);

import styled from 'styled-components';

export var StyledUl = styled.ul(_templateObject, function (props) {
  return props.theme.tabletWidth;
});

export var StyledButton = styled.button(_templateObject2, function (props) {
  return props.theme.dormifyBlack;
});